import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NexusAlertComponent } from './nexus-alert/nexus-alert.component';
import { ImgEnvioComponent } from './img-envio/img-envio.component';
import { ProgressComponent } from './progress/progress.component';

@NgModule({
  declarations: [
    NexusAlertComponent,
    ImgEnvioComponent,
    ProgressComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NexusAlertComponent,
    ImgEnvioComponent,
    ProgressComponent,
  ]
})
export class UtilModule { }
